(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["media-caption-glass"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('glass-media-caption-v6')) {
    customElements.define(
      'glass-media-caption-v6',
      class GlassMediaCaptionV6 extends HTMLElement {
        static get observedAttributes() {
          return ['data-media-index', 'data-all-media'];
        }

        connectedCallback() {
          this.instanceId = `gmc-v6-${Math.random().toString(36).slice(2)}`;
          this.portals = new Map();
          this.scrollers = new Set();
          this.productRoot = this.closest('[id^="MainProduct-"]');
          this.sourceLayer = this.querySelector('[data-gmc-v6-layer]');

          this._onMove = () => this.updateAllVisibility();
          this._onEditorEvent = () => this.schedule();

          window.addEventListener('resize', this._onMove, { passive: true });
          window.addEventListener('scroll', this._onMove, { passive: true });
          document.addEventListener('shopify:section:load', this._onEditorEvent);
          document.addEventListener('shopify:block:select', this._onEditorEvent);
          document.addEventListener('shopify:block:deselect', this._onEditorEvent);

          this.watchSource();
          this.watchGallery();
          this.schedule();
        }

        disconnectedCallback() {
          if (this.sourceObserver) this.sourceObserver.disconnect();
          if (this.galleryObserver) this.galleryObserver.disconnect();
          this.unbindScrollers();
          window.removeEventListener('resize', this._onMove);
          window.removeEventListener('scroll', this._onMove);
          document.removeEventListener('shopify:section:load', this._onEditorEvent);
          document.removeEventListener('shopify:block:select', this._onEditorEvent);
          document.removeEventListener('shopify:block:deselect', this._onEditorEvent);
          this.removeAllPortals();
        }

        attributeChangedCallback() {
          if (this.isConnected) this.schedule();
        }

        schedule() {
          if (this._pending) return;
          this._pending = true;
          window.requestAnimationFrame(() => {
            this._pending = false;
            this.coordinate();
          });
        }

        gallery() {
          return this.productRoot
            ? this.productRoot.querySelector('[id^="MediaGallery-"]:not([id$="-duplicate"])')
            : null;
        }

        mediaItems(gallery) {
          let items = [...gallery.querySelectorAll('.product__media-item')];
          if (!items.length) items = [...gallery.querySelectorAll('li[id^="Slide-"]')];
          if (!items.length) items = [...gallery.querySelectorAll('.product-media-container')];
          return items;
        }

        mediaHost(item) {
          if (!item) return null;
          if (item.matches('.product-media-container')) return item;
          return item.querySelector('.product-media-container') || item;
        }

        coordinate() {
          if (!this.isConnected) return;

          this.productRoot = this.closest('[id^="MainProduct-"]') || this.productRoot;
          this.sourceLayer = this.querySelector('[data-gmc-v6-layer]') || this.sourceLayer;

          const gallery = this.gallery();
          if (!gallery || !this.sourceLayer) return;

          const items = this.mediaItems(gallery);
          const selectedIndex = Math.max(1, parseInt(this.dataset.mediaIndex, 10) || 1) - 1;
          const targets = this.dataset.allMedia === 'true'
            ? items.map((item, index) => ({ key: `all-${index}`, item }))
            : items[selectedIndex]
              ? [{ key: `single-${selectedIndex}`, item: items[selectedIndex] }]
              : [];

          const wanted = new Set(targets.map((target) => target.key));
          for (const [key, entry] of this.portals) {
            if (!wanted.has(key) || !entry.portal.isConnected) this.removePortal(key);
          }

          const signature = this.sourceLayer.outerHTML;

          for (const target of targets) {
            const host = this.mediaHost(target.item);
            if (!host) continue;
            host.classList.add('gmc-v6-host');

            let entry = this.portals.get(target.key);
            if (!entry || entry.host !== host || !entry.portal.isConnected) {
              if (entry) this.removePortal(target.key);

              const portal = document.createElement('div');
              portal.className = 'gmc-v6-portal';
              portal.dataset.gmcV6Owner = this.dataset.captionOwner || '';
              portal.dataset.gmcV6Instance = this.instanceId;
              host.appendChild(portal);

              entry = { portal, host, item: target.item, signature: '' };
              this.portals.set(target.key, entry);
            } else {
              entry.item = target.item;
            }

            if (entry.signature !== signature) {
              entry.portal.replaceChildren(this.sourceLayer.cloneNode(true));
              entry.signature = signature;
            }
          }

          this.bindScrollers();
          this.updateAllVisibility();
        }

        watchSource() {
          if (!this.sourceLayer || typeof MutationObserver === 'undefined') return;
          this.sourceObserver = new MutationObserver(() => this.schedule());
          this.sourceObserver.observe(this.sourceLayer, {
            attributes: true,
            childList: true,
            subtree: true,
            characterData: true
          });
        }

        watchGallery() {
          const gallery = this.gallery();
          if (!gallery || typeof MutationObserver === 'undefined') return;
          this.galleryObserver = new MutationObserver((records) => {
            const onlyOurPortals = records.every((record) => {
              const target = record.target.nodeType === 1 ? record.target : record.target.parentElement;
              return target && target.closest && target.closest(`.gmc-v6-portal[data-gmc-v6-instance="${this.instanceId}"]`);
            });
            if (!onlyOurPortals) this.schedule();
          });
          this.galleryObserver.observe(gallery, { childList: true, subtree: true });
        }

        findScroller(host) {
          let node = host;
          while (node && node !== document.body) {
            const style = window.getComputedStyle(node);
            if (/(auto|scroll)/.test(style.overflowX)) return node;
            node = node.parentElement;
          }
          return this.gallery();
        }

        bindScrollers() {
          this.unbindScrollers();
          for (const entry of this.portals.values()) {
            const scroller = this.findScroller(entry.host);
            entry.scroller = scroller;
            if (scroller && !this.scrollers.has(scroller)) {
              scroller.addEventListener('scroll', this._onMove, { passive: true });
              this.scrollers.add(scroller);
            }
          }
        }

        unbindScrollers() {
          for (const scroller of this.scrollers || []) {
            scroller.removeEventListener('scroll', this._onMove);
          }
          if (this.scrollers) this.scrollers.clear();
        }

        updateAllVisibility() {
          for (const entry of this.portals.values()) {
            const layer = entry.portal.querySelector('[data-gmc-v6-layer]');
            if (!layer) continue;

            if (layer.dataset.gate !== 'true') {
              layer.classList.add('gmc-v6-layer--active');
              continue;
            }

            const rect = entry.item.getBoundingClientRect();
            const bounds = entry.scroller
              ? entry.scroller.getBoundingClientRect()
              : { left: 0, right: window.innerWidth };
            const centre = rect.left + rect.width / 2;
            const active = rect.width > 0 && centre > bounds.left + 2 && centre < bounds.right - 2;
            layer.classList.toggle('gmc-v6-layer--active', active);
          }
        }

        removePortal(key) {
          const entry = this.portals.get(key);
          if (!entry) return;
          if (entry.portal && entry.portal.dataset.gmcV6Instance === this.instanceId) {
            entry.portal.remove();
          }
          this.portals.delete(key);
        }

        removeAllPortals() {
          if (!this.portals) return;
          for (const key of [...this.portals.keys()]) this.removePortal(key);
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["product-page-badge"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('product-page-badge')) {
    customElements.define(
      'product-page-badge',
      class ProductPageBadge extends HTMLElement {
        connectedCallback() {
          this.productRoot = this.closest('[id^="MainProduct-"]');
          this.layer = this.querySelector('[data-product-page-badge-layer]');
          this.scheduleCoordination();
        }

        disconnectedCallback() {
          const root = this.productRoot;
          if (this.layer && !this.contains(this.layer)) this.layer.remove();
          window.requestAnimationFrame(() => this.coordinate(root));
        }

        scheduleCoordination() {
          window.requestAnimationFrame(() => this.coordinate(this.productRoot));
        }

        coordinate(root) {
          if (!root || !root.isConnected) return;

          const candidates = Array.from(
            root.querySelectorAll('product-page-badge[data-badge-active="true"]')
          ).filter((candidate) => candidate.layer);
          const specific = candidates.find((candidate) => candidate.dataset.badgeScope === 'specific');
          const global = candidates.find((candidate) => candidate.dataset.badgeScope === 'all');
          const winner = specific || global;

          candidates.forEach((candidate) => {
            candidate.layer.hidden = candidate !== winner;
          });

          root.classList.toggle(
            'dl-hide-product-trust-badge',
            Boolean(winner && winner.dataset.hideTrustBadge === 'true')
          );

          if (!winner || !winner.layer) return;

          const gallery = root.querySelector('[id^="MediaGallery-"]:not([id$="-duplicate"])');
          let host = gallery;

          if (gallery && winner.dataset.placementArea === 'media-column') {
            host = gallery.closest('.product__media-wrapper') || gallery.parentElement;
          }

          host = host || root.querySelector('.product__media-wrapper') || root.querySelector('.product');
          if (!host) return;

          host.classList.add('dl-product-page-badge-host');
          if (winner.layer.parentElement !== host) host.appendChild(winner.layer);
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["reviews"] && !Shopify.designMode) return;
  try {
    (() => {
    const init = (root) => {
      if (!root || root.dataset.rpInitialized === 'true') return;
      root.dataset.rpInitialized = 'true';

      if (root.dataset.layout !== 'carousel') return;

      const track = root.querySelector('[data-rp-track]');
      const slides = Array.from(root.querySelectorAll('[data-rp-slide]'));
      const prev = root.querySelector('[data-rp-prev]');
      const next = root.querySelector('[data-rp-next]');
      const dotsWrap = root.querySelector('[data-rp-dots]');
      const mode = root.dataset.sliderType || 'slide';
      const autoplay = root.dataset.autoplay === 'true';
      const delay = Math.max(Number(root.dataset.autoplaySpeed) || 5000, 1000);
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      if (!track || slides.length < 2) return;

      let index = 0;
      let timer = null;
      let scrollRaf = null;
      const dots = [];

      const visibleCount = () => {
        if (mode === 'fade') return 1;
        const trackWidth = track.clientWidth || 1;
        const slideWidth = slides[0].getBoundingClientRect().width || trackWidth;
        return Math.max(1, Math.round(trackWidth / slideWidth));
      };

      const maxIndex = () => Math.max(0, slides.length - visibleCount());

      const syncButtons = () => {
        if (mode === 'loop') {
          if (prev) prev.disabled = false;
          if (next) next.disabled = false;
          return;
        }
        if (prev) prev.disabled = index <= 0;
        if (next) next.disabled = index >= maxIndex();
      };

      const syncDots = () => {
        dots.forEach((dot, dotIndex) => {
          const active = dotIndex === index;
          dot.classList.toggle('is-active', active);
          dot.setAttribute('aria-current', active ? 'true' : 'false');
        });
      };

      const renderFade = () => {
        slides.forEach((slide, slideIndex) => {
          const active = slideIndex === index;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', active ? 'false' : 'true');
        });
      };

      const goTo = (requested, behavior = 'smooth') => {
        const last = mode === 'fade' ? slides.length - 1 : maxIndex();

        if (mode === 'loop') {
          if (requested > last) requested = 0;
          if (requested < 0) requested = last;
        } else {
          requested = Math.max(0, Math.min(requested, last));
        }

        index = requested;

        if (mode === 'fade') {
          renderFade();
        } else {
          const target = slides[index];
          if (target) {
            track.scrollTo({ left: target.offsetLeft, behavior: reducedMotion ? 'auto' : behavior });
          }
        }

        syncButtons();
        syncDots();
      };

      if (dotsWrap) {
        slides.forEach((_, dotIndex) => {
          const dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'reviews-pro__dot';
          dot.setAttribute('aria-label', `Go to review ${dotIndex + 1}`);
          dot.addEventListener('click', () => goTo(dotIndex));
          dotsWrap.appendChild(dot);
          dots.push(dot);
        });
      }

      if (mode !== 'fade') {
        track.addEventListener('scroll', () => {
          if (scrollRaf) cancelAnimationFrame(scrollRaf);
          scrollRaf = requestAnimationFrame(() => {
            let nearest = 0;
            let distance = Infinity;
            slides.forEach((slide, slideIndex) => {
              const currentDistance = Math.abs(slide.offsetLeft - track.scrollLeft);
              if (currentDistance < distance) {
                nearest = slideIndex;
                distance = currentDistance;
              }
            });
            index = Math.min(nearest, maxIndex());
            syncButtons();
            syncDots();
          });
        }, { passive: true });
      }

      prev?.addEventListener('click', () => goTo(index - 1));
      next?.addEventListener('click', () => goTo(index + 1));

      const stop = () => {
        if (timer) window.clearInterval(timer);
        timer = null;
      };

      const start = () => {
        stop();
        if (!autoplay || reducedMotion || document.hidden) return;
        timer = window.setInterval(() => goTo(index + 1), delay);
      };

      root.addEventListener('mouseenter', stop);
      root.addEventListener('mouseleave', start);
      root.addEventListener('focusin', stop);
      root.addEventListener('focusout', start);
      document.addEventListener('visibilitychange', () => document.hidden ? stop() : start());
      window.addEventListener('resize', () => goTo(Math.min(index, maxIndex()), 'auto'));

      goTo(0, 'auto');
      start();
    };

    const initAll = (scope = document) => {
      scope.querySelectorAll('[data-reviews-pro]').forEach(init);
    };

    initAll();
    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
    document.addEventListener('shopify:block:select', (event) => {
      const root = event.target.matches?.('[data-reviews-pro]') ? event.target : event.target.querySelector?.('[data-reviews-pro]');
      init(root);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
